// src/app/core/services/otp-challenge.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface OtpChallenge {
  feature: string;
  resolve: () => void;
}

@Injectable({ providedIn: 'root' })
export class OtpChallengeService {
  private challengeSubject = new Subject<OtpChallenge>();
  challenge$ = this.challengeSubject.asObservable();

  // Called by the interceptor/guard — resolves once the modal is dismissed verified
  requestChallenge(feature: string): Promise<void> {
    return new Promise((resolve) => {
      this.challengeSubject.next({ feature, resolve });
    });
  }
}